module.exports = __webpack_public_path__ + "img/budget-alocated-icon.72da8401.svg";